import { CssBaseline } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import React from "react";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import { interceptors } from "./interceptors/interceptors";
import { Routes } from "./routes";
import ReportingComponent from "./views/components/reporting-component/reporting-component";
import "react-quill/dist/quill.snow.css";
import "react-calendar/dist/Calendar.css";

interceptors.errorInterceptor();

const theme = createTheme({
   typography: {
      fontFamily: "Poppins",
   },
});

function App() {
   return (
      <BrowserRouter>
         <ThemeProvider theme={theme}>
            <CssBaseline />
            <ReportingComponent />
            <Routes />
         </ThemeProvider>
      </BrowserRouter>
   );
}

export default App;
